// extracted by mini-css-extract-plugin
export default {"container":"Stretch_container__xVWeI","preview":"Stretch_preview__hzHw-"};